import script from "./Breadcrumbs.vue?vue&type=script&setup=true&lang=ts"
export * from "./Breadcrumbs.vue?vue&type=script&setup=true&lang=ts"

import "./Breadcrumbs.vue?vue&type=style&index=0&id=06141a74&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06141a74"]])

export default __exports__